<template>
  <div>
    <div class="top-bg">
    </div>
    <div class="top-user">
      <nut-cell :show-icon="true" :title="user.nickname" sub-title="18507315674" desc="账号设置、切换" class="item"
                @click-cell="goAccounts()">
        <div slot="avatar"><img class="img-icon"
                                :src='user.avatar ? imgUrl + user.avatar : require("@/resource/img/device/headImg.png")'/>
        </div>
      </nut-cell>
      <nut-cell v-if="user.role == 2" :show-icon="true" title="品牌信息设置" @click-cell="goBrandInfo()">
        <div slot="avatar">
          <img :src='require("@/resource/img/device/info-inform.png")'
               style="width:auto;height:20px;margin-right: 12px;"/>
        </div>
      </nut-cell>
      <nut-cell v-if="user.role != 2" :show-icon="true" title="物料管理" desc="生成二维码、下载物料">
        <div slot="avatar">
          <img :src='require("@/resource/img/device/download-icon.png")'
               style="width:auto;height:20px;margin-right: 12px;"/>
        </div>
      </nut-cell>
    </div>
    <nut-cell v-if="user.role == 2" :show-icon="true" title="物料管理" desc="生成二维码、下载物料"
              style="margin: 60px 15px 20px 15px;border-radius: 5px;">
      <div slot="avatar">
        <img :src='require("@/resource/img/device/download-icon.png")'
             style="width:auto;height:20px;margin-right: 12px;"/>
      </div>
    </nut-cell>
    <nut-cell v-if="user.role == 2" :show-icon="true" title="投放地址" style="margin: 0px 15px;border-radius: 5px;"
              @click-cell="goAddress()">
      <div slot="avatar">
        <img :src='require("@/resource/img/device/map.png")'
             style="width:auto;height:25px;margin-right: 12px;"/>
      </div>
    </nut-cell>
    <nut-cell v-if="user.role == 2" :show-icon="true" title="设备操作记录" style="margin: 0px 15px;border-radius: 5px;"
              @click-cell="goRecord()">
      <div slot="avatar">
        <img :src='require("@/resource/img/device/record.png")'
             style="width:auto;height:24px;margin-right: 12px;"/>
      </div>
    </nut-cell>
    <nut-cell v-if="user.role == 2" :show-icon="true" title="wifi配网" style="margin: 0px 15px;border-radius: 5px;"
              @click-cell="goWifi()">
      <div slot="avatar">
        <img :src='require("@/resource/img/device/wifi.png")'
             style="width:auto;height:24px;margin-right: 12px;"/>
      </div>
    </nut-cell>
    <MTab :index="2"/>
  </div>
</template>

<script>
/**
 * 我的
 */
export default {
  name: 'DeviceMy',
  data() {
    return {
      imgUrl: sessionStorage.url || require ('../../Common/common').default.URL,
      user: {}
    }
  },
  mounted() {
    this.user = this.$api.user
  },
  methods: {
    //帐号设置
    goAccounts() {
      this.$router.push ('/device/AccountsSet')
    },
    //品牌信息设置
    goBrandInfo() {
      this.$router.push ('/device/BrandInfoSet')
    },
    //设备地址
    goAddress() {
      this.$router.push ('/device/LaunchAddress')
    },
    //设备操作记录
    goRecord() {
      this.$router.push ('/device/OperateRecord')
    },
    goWifi() {
      this.$router.push ('/device/Wifi')
    }
  }
}
</script>

<style scoped>
.top-bg {
  height: 90px;
  background-color: #32353C;
}

.top-user {
  background-color: #fff;
  height: 120px;
  position: absolute;
  top: 10px;
  left: 15px;
  right: 15px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
}

.top-user .item {
  border-radius: 5px;
  padding: 10px;
}

.img-icon {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  border-radius: 50%;
  border: 2px solid rgba(211, 211, 211, 0.49);
}
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceMy.vue